import { NzConfig } from 'ng-zorro-antd/core/config';

export const vvcNgZorroConfig: NzConfig = {
  notification: {
    nzTop: 50,
    nzDuration: 10000
  }
};
